import { appendCloudinaryAccessToken } from '@mntn/image-utils'
import { createContext, type ReactNode, useCallback, useContext } from 'react'

// Cloudinary uses the current session token to authorize browser requests for tenant-scoped media.
const CloudinaryAccessUrlContext = createContext<(url: string) => string>(url => url)

export const CloudinaryAccessTokenProvider = ({
  accessToken,
  children,
}: {
  accessToken?: string
  children: ReactNode
}) => {
  const accessUrl = useCallback((url: string) => appendCloudinaryAccessToken(url, accessToken), [accessToken])

  return <CloudinaryAccessUrlContext.Provider value={accessUrl}>{children}</CloudinaryAccessUrlContext.Provider>
}

export const useCloudinaryAccessUrl = () => useContext(CloudinaryAccessUrlContext)
